
import {GET_LIST_TEMPLATE, CREATE_PICKUP_TEMPLATE, GET_DETAIL_PICKUP_TEMPLATE, DELETE_PICKUP_TEMPLATE, UPDATE_PICKUP_TEMPLATE, GET_ALL_PICKUP_TEMPLATE  } from '@/api/phase2/pickupTemplate'

export default {
  getListPickupTemplate ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_LIST_TEMPLATE({ payload }, successCallback, errorCallback)
  },

  createPickupTemplate ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    CREATE_PICKUP_TEMPLATE({ payload }, successCallback, errorCallback)
  },

  getDetailPickupTemplate ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_DETAIL_PICKUP_TEMPLATE({ payload }, successCallback, errorCallback)
  },

  updatePickupTemplate ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    UPDATE_PICKUP_TEMPLATE({ payload }, successCallback, errorCallback)
  },

  deletePickupTemplate ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    DELETE_PICKUP_TEMPLATE({ payload }, successCallback, errorCallback)
  },
  getAllPickupTemplate({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_ALL_PICKUP_TEMPLATE({ payload }, successCallback, errorCallback)
  },
};
